import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import * as c from '../../helpers/constants'
import { callApi } from '../../helpers/methods'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listaAction } from '../../store/lista';

//COMPONENTS
import {Modal, Button, Icon} from '../inspinia'

class ModalSucesso extends React.Component
{
    constructor(props)
    {
        super(props);

        this.handleVoltarClick = this.handleVoltarClick.bind(this);
        this.handleNovaClick   = this.handleNovaClick.bind(this);
    }

    handleVoltarClick()
    {
        this.props.actions.lista.finalizar().then(() => 
        {
            this.props.history.push(c.DEFAULT_PRIVATE_ROUTE);
        });
    }

    handleNovaClick()
    {
        this.props.actions.lista.finalizar().then(() => 
        {
            this.props.history.push(c.CAMPAIGN_ROUTE+"/criar");
        });
    }

    render()
    {
        return (                       
            <Modal isOpen={this.props.isOpen} toggle={this.props.toggle}>              
                <img src="assets/images/Image 2.png" alt="" />
                                    
                <h3 className="fs-20 fw-600 text-body">
                    Sua lista de contatos foi enviada para processamento, favor aguardar o e-mail de confirmação de processamento.
                </h3>

                <div className="input-group d-block text-center mt-4">
                    <Button onClick={this.handleVoltarClick} className="btn btn-outline btn-primary mx-1" style={{width: "174px"}}><Icon name="fa-arrow-left" className="mr-2"/> Voltar para o painel</Button>                    
                </div>
            </Modal>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, lista: state.lista };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ModalSucesso));
